import { FC, useEffect, useRef, useState } from 'react';
import { Badge, Box, Button, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from 'pages/task/Task.module.css';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { RoutesType } from 'shared/types/routes/routers-type';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { resetFileData } from 'entities/task';

import appStyles from 'app/providers/theme/App.module.css';
import Loader from 'shared/loader/Loader';
import CustomButton from 'shared/custom-button/CustomButton';
import EditIcon from '@mui/icons-material/Edit';
import { CustomTabPanel } from 'shared/custom-tab-panel/custom-tab-panel';
import { TaskInfoComponent } from 'features/task/ui/TaskInfo';
import { FileData, isLoadingTaskInfo, TaskInfo, Download, FileName, selectIsLoading, StatusHistory, TaskMessages, Files, ApproveTask, isLoadingApproveTask } from 'entities/task-new/selector';
import { fetchFileDownload, fetchTaskCase, fetchTaskFiles, fetchTaskMessages, fetchTaskStatusHistory } from 'entities/task-new/actions/fetch-task-case';
import ForumIcon from '@mui/icons-material/Forum';
import MessagesComponent from 'features/task/ui/MessagesComponent';
import Pdf from 'shared/assets/pdf';
import FilesComponent from 'features/task/ui/FilesComponent';
import AnswerApprove from 'features/task/ui/AnswerApprove';
import { resetApproveTask } from 'entities/task-new';
import ModalNew from 'shared/modal-new/ModalNew';

export const Task: FC = () => {
    const dispatch = useAppDispatch();
    const taskInfo = useAppSelector(TaskInfo);
    const isLoading = useAppSelector(isLoadingTaskInfo);
    const loadingStatistics = useAppSelector(selectIsLoading);
    const statusHistory = useAppSelector(StatusHistory);


    const navigate = useNavigate();
    const location = useLocation();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const idTask = query.get('id');

    const taskMessages = useAppSelector(TaskMessages);
    const [countUnreadMessages, setCountUnreadMessages] = useState(0);
    useEffect(() => {
        if (taskMessages.Messages && Array.isArray(taskMessages.Messages)) {
            const unreadCount = taskMessages.Messages.filter((message) => !message.Read).length;
            setCountUnreadMessages(unreadCount);
        }
    }, [taskMessages.Messages]);


    useEffect(() => {
        if (idTask) {
            dispatch(fetchTaskCase({ TaskID: idTask }));
            dispatch(fetchTaskStatusHistory({ TaskID: idTask }));
            dispatch(fetchTaskMessages({ TaskID: idTask }));
            dispatch(fetchTaskFiles({ TaskID: idTask }));
        } else {
            console.error('Missing idCase');
        }
    }, [dispatch, idTask]);


    const handleClickBack = () => {
        if (location.state?.fromInsuranceContractPage) {
            navigate(`/insurance-contracts/case/?id=${location.state.id}`, {
                state: {
                    textRout: 'insurance-contracts',
                    name: 'Договоры страхования',
                    activeTab: location.state.activeTab
                }
            });
        } else {
            navigate(`${RoutesType.TasksList}`, {
                state: {
                    textRout: 'applications',
                    name: 'Заявки'
                }
            });
        }
    };

    const handleClickEdit = () => {
        navigate(RoutesType.EditTask, {
            state: { taskInfo: taskInfo }
        });
    }

    const isDownload = useAppSelector(Download);

    const [value, setValue] = useState(0);
    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const tabsRef = useRef<HTMLDivElement>(null);
    const handleWheel = (event: React.WheelEvent) => {
        if (tabsRef.current) {
            const tabsContainer = tabsRef.current.querySelector('.MuiTabs-scroller');
            if (tabsContainer) {
                tabsContainer.scrollLeft += event.deltaY * 4;
            }
        }
    };

    const approveTask = useAppSelector(ApproveTask);
    const isLoadingApprove = useAppSelector(isLoadingApproveTask);
    const handleClickChat = () => {
        setValue(1);
    }
    useEffect(() => {
        return () => {
            dispatch(resetApproveTask());
        };
    }, []);

    if (approveTask.ID && approveTask.Number) {
        return (
            <AnswerApprove
                id={approveTask.ID}
                idContract={location.state?.id ? location.state.id : null}
            />
        )
    } else if (isLoadingApprove) {
        return (
            <Loader
                title='Обновление статуса... Пожалуйста, подождите'
            />
        )
    } else {
        return (
            <Box>
                {isDownload && (
                    <Loader
                        title='Файл скачивается... Пожалуйста, подождите'
                    />
                )}

                {loadingStatistics !== 0 && (
                    <Loader
                        title='Загрузка...'
                    />
                )}
                {loadingStatistics === 0 && !isDownload && (
                    <>
                        <Box className={appStyles.titleBox}>
                            <h1>Заявка <span>{taskInfo ? taskInfo.Number : ''}</span></h1>

                            <Box className={appStyles.titleBtn}>
                                <Button onClick={handleClickBack} className={appStyles.btnBack}><KeyboardBackspaceIcon /> Назад к списку договоров</Button>
                            </Box>
                        </Box>
                        <Box className={styles.flexRowBox}>
                            <Box className={styles.flexColumnBox}>
                                <Box className={styles.statusBox}>
                                    <p className={styles.status}>
                                        Статус:
                                        <span className={
                                            taskInfo.StatusName === 'Выполнено' ? styles.green :
                                                taskInfo.StatusName === 'Проект' ? styles.yellow :
                                                    taskInfo.StatusName === 'Отменено' ? styles.red :
                                                        styles.yellow
                                        }>
                                            <span className={`${styles.statusIndicator} ${taskInfo.StatusName === 'Выполнено' ? styles.greenIndicator :
                                                taskInfo.StatusName === 'Проект' ? styles.yellowIndicator :
                                                    taskInfo.StatusName === 'Отменено' ? styles.redIndicator :
                                                        styles.yellowIndicator
                                                }`}></span>
                                            {taskInfo.StatusName}
                                        </span>
                                    </p>
                                </Box>
                                <Box className={styles.statusBox}>
                                    <p className={styles.status}>
                                        Статус согласования:
                                        {taskInfo.AgreementResultName ? (
                                            <span className={styles.blue}>
                                                <span className={`${styles.statusIndicator} ${styles.blueIndicator}`}></span>
                                                {taskInfo.AgreementResultName ? taskInfo.AgreementResultName : '-'}
                                            </span>
                                        ) : (
                                            <span>-</span>
                                        )}

                                    </p>
                                </Box>
                            </Box>
                            <Box>
                                <CustomButton
                                    title="Написать в чат"
                                    icon={ForumIcon}
                                    leftIcon={true}
                                    handleClick={handleClickChat}
                                    textColor="#0054E6"
                                    backgroundColor="#ccd2db7e"
                                    gap="10px"
                                    border='none'
                                    borderRadius='4px'
                                    padding="8px 20px"
                                />
                            </Box>
                        </Box>



                        <Box onWheel={handleWheel} ref={tabsRef} className={styles.tabsBox}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        backgroundColor: '#0054E6'
                                    },
                                }}
                            >
                                <Tab
                                    label="Данные заявки"
                                    {...a11yProps(0)}
                                    sx={{
                                        '&.Mui-selected': {
                                            color: '#0054E6 !important',
                                        },
                                    }}
                                />
                                <Tab
                                    label={
                                        <Badge
                                            color="error"
                                            badgeContent={countUnreadMessages}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            sx={{
                                                '& .MuiBadge-badge': {
                                                    fontSize: '0.7rem',
                                                    height: '14px',
                                                    width: '14px',
                                                    minWidth: '14px',
                                                    padding: '0 4px',
                                                    top: '-4px',
                                                    right: '-5px',
                                                },
                                            }}
                                        >
                                            Сообщения
                                        </Badge>
                                    }
                                    {...a11yProps(1)}
                                    sx={{
                                        '&.Mui-selected': {
                                            color: '#0054E6 !important',
                                        },
                                    }}
                                />
                                <Tab
                                    label="История изменения статусов"
                                    {...a11yProps(2)}
                                    sx={{
                                        '&.Mui-selected': {
                                            color: '#0054E6 !important',
                                        },
                                    }}
                                />
                                <Tab
                                    label="Файлы"
                                    {...a11yProps(3)}
                                    sx={{
                                        '&.Mui-selected': {
                                            color: '#0054E6 !important',
                                        },
                                    }}
                                />
                            </Tabs>
                        </Box>

                        <CustomTabPanel value={value} index={0}>
                            <TaskInfoComponent />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={1}>
                            <MessagesComponent />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={2}>
                            <Box className={styles.historyStatus}>
                                <p className={styles.title}>История изменения статусов</p>
                                <Box className={styles.list}>
                                    {statusHistory.StatusHistory.map((item, index) => (
                                        <p key={index}>{item.Date} - {item.StatusName}</p>
                                    ))}
                                </Box>
                            </Box>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={3}>
                            <FilesComponent />

                        </CustomTabPanel>

                        {taskInfo.StatusName === 'Проект' && (
                            <Box className={styles.btnBox}>
                                <CustomButton
                                    title="Редактировать"
                                    icon={EditIcon}
                                    leftIcon={true}
                                    handleClick={handleClickEdit}
                                    textColor="white"
                                    backgroundColor="#0054E6"
                                    gap="10px"
                                    border='none'
                                    borderRadius='4px'
                                    padding="8px 30px"
                                />
                            </Box>

                        )}
                    </>
                )}
            </Box>
        );
    }



};

export default Task;
